'use client';

import { useAppDispatch } from '@/store';
import { openModal } from '@/store/slices/ui.slice';

export const useOpenAuthModal = () => {
  const dispatch = useAppDispatch();
  return () => dispatch(openModal('signIn'));
};
